export enum CustomFieldEntity {
  PROGRAM = "PROGRAM",
  BRANCH = "BRANCH",
}

export enum CustomFieldValueType {
  TEXT = "TEXT",
  TEXTAREA = "TEXTAREA",
  NUMBER = "NUMBER",
  MONEY = "MONEY",
  MEMBER = "MEMBER",
  PHONE = "PHONE",
  WHATSAPP = "WHATSAPP",
  LINK = "LINK",
  DATE = "DATE",
  DATETIME = "DATETIME",
  BOOLEAN = "BOOLEAN",
}

export interface CustomFieldMoneyValue {
  amount: number | null
  currency: string
}

export type CustomFieldValue = string | number | boolean | null | CustomFieldMoneyValue

export interface CustomFieldTemplate {
  id: string
  entity: CustomFieldEntity
  key: string
  label: string
  valueType: CustomFieldValueType
  isRequired: boolean
  isActive: boolean
  source?: string
  createdAt: string
  updatedAt: string
}

export interface AdHocFieldValue {
  id: string
  label: string
  valueType: CustomFieldValueType
  value: CustomFieldValue
}
